import React, { useEffect, useRef } from 'react';

// Shopify Buy Button configuration for each product
const SHOPIFY_CONFIG = {
  domain: 'x16ha3-n1.myshopify.com',
  storefrontAccessToken: 'f1f5374c07806735e6632074755592e5',
};

const PRODUCT_IDS = {
  '1': { shopifyId: '9150818091262', containerId: 'product-component-1773338569519' }, // THE CUFF SET
  '2': { shopifyId: '9151135908094', containerId: 'product-component-1773338615058' }, // THE LAYER
  '3': { shopifyId: '9151135252734', containerId: 'product-component-1773338645182' }, // THE STACK
  '4': { shopifyId: '9151135580414', containerId: 'product-component-bangle' }, // THE BANGLE
  '5': { shopifyId: '9151224283390', containerId: 'product-component-1773338680973' }, // THE DROP
  '6': { shopifyId: '9151224512766', containerId: 'product-component-1773338705457' }, // THE MELT
  '7': { shopifyId: '9151225069822', containerId: 'product-component-1773338723556' }, // THE SIGNET
  '8': { shopifyId: '9151224709374', containerId: 'product-component-1773338735722' }, // THE CUBAN
  'lighter': { shopifyId: '9162088808702', containerId: 'product-component-lighter' }, // THE LIGHTER
  'watch': { shopifyId: '9162448929022', containerId: 'product-component-watch' }, // THE WATCH
  'bag': { shopifyId: '9175528407294', containerId: 'product-component-bag' }, // THE BAG
  // New products
  '12': { shopifyId: '9228401115390', containerId: 'product-component-tear' }, // THE TEAR
  '13': { shopifyId: '9228400754942', containerId: 'product-component-pour' }, // THE POUR
  '14': { shopifyId: '9228400034046', containerId: 'product-component-wave' }, // THE WAVE
  '15': { shopifyId: '9228396626174', containerId: 'product-component-chain' }, // THE CHAIN
  '16': { shopifyId: '9228395610366', containerId: 'product-component-line' }, // THE LINE
};

const ShopifyBuyButton = ({ productId }) => {
  const initialized = useRef(false);
  const productConfig = PRODUCT_IDS[productId];

  useEffect(() => {
    if (!productConfig || initialized.current) return;

    const loadShopifyBuyButton = () => {
      if (window.ShopifyBuy && window.ShopifyBuy.UI) {
        initShopifyBuy();
      } else {
        loadScript();
      }
    };

    const loadScript = () => {
      const existingScript = document.querySelector('script[src*="buy-button-storefront"]');
      if (existingScript) {
        existingScript.onload = initShopifyBuy;
        if (window.ShopifyBuy && window.ShopifyBuy.UI) {
          initShopifyBuy();
        }
        return;
      }

      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://sdks.shopifycdn.com/buy-button/latest/buy-button-storefront.min.js';
      script.onload = initShopifyBuy;
      document.head.appendChild(script);
    };

    const initShopifyBuy = () => {
      if (!window.ShopifyBuy || initialized.current) return;
      
      const client = window.ShopifyBuy.buildClient({
        domain: SHOPIFY_CONFIG.domain,
        storefrontAccessToken: SHOPIFY_CONFIG.storefrontAccessToken,
      });

      window.ShopifyBuy.UI.onReady(client).then((ui) => {
        const node = document.getElementById(productConfig.containerId);
        if (!node || initialized.current) return;
        
        initialized.current = true;
        
        // Store UI reference globally for cart access
        window.shopifyBuyUI = ui;
        
        ui.createComponent('product', {
          id: productConfig.shopifyId,
          node: node,
          moneyFormat: '%24%7B%7Bamount%7D%7D',
          options: {
            product: {
              styles: {
                product: {
                  "@media (min-width: 601px)": {
                    "max-width": "100%",
                    "margin-left": "0px",
                    "margin-bottom": "0px"
                  }
                },
                button: {
                  "font-family": "'Barlow Condensed', sans-serif",
                  "font-weight": "700",
                  "font-size": "16px",
                  "padding": "16px 32px",
                  "background-color": "#0D0D0B",
                  "color": "#FDFAF4",
                  "text-transform": "uppercase",
                  "letter-spacing": "0.1em",
                  ":hover": {
                    "background-color": "#E8F53A",
                    "color": "#0D0D0B"
                  },
                  ":focus": {
                    "background-color": "#E8F53A",
                    "color": "#0D0D0B"
                  },
                  "border-radius": "0px"
                },
                title: {
                  "display": "none"
                },
                price: {
                  "display": "none"
                },
                compareAt: {
                  "display": "none"
                },
                description: {
                  "display": "none"
                }
              },
              contents: {
                img: false,
                title: false,
                price: false,
                description: false,
                button: true,
                buttonWithQuantity: false,
                quantity: false
              },
              text: {
                button: "Add to Cart"
              }
            },
            cart: {
              styles: {
                button: {
                  "font-family": "'Barlow Condensed', sans-serif",
                  "font-weight": "700",
                  "background-color": "#0D0D0B",
                  "color": "#FDFAF4",
                  ":hover": {
                    "background-color": "#E8F53A",
                    "color": "#0D0D0B"
                  },
                  "border-radius": "0px"
                }
              },
              text: {
                total: "Subtotal",
                button: "Checkout"
              },
              events: {
                afterInit: (cart) => {
                  window.shopifyCart = cart.model;
                  const event = new CustomEvent('shopify-cart-update', {
                    detail: {
                      count: cart.model?.lineItemCount || 0,
                      checkoutUrl: cart.model?.webUrl
                    }
                  });
                  window.dispatchEvent(event);
                },
                updateItemQuantity: (cart) => {
                  window.shopifyCart = cart.model;
                  const event = new CustomEvent('shopify-cart-update', {
                    detail: {
                      count: cart.model?.lineItemCount || 0,
                      checkoutUrl: cart.model?.webUrl
                    }
                  });
                  window.dispatchEvent(event);
                }
              }
            },
            toggle: {
              styles: {
                toggle: {
                  "display": "none",
                  "visibility": "hidden"
                },
                count: {
                  "display": "none"
                }
              }
            },
            cart: {
              popup: false,
              events: {
                afterInit: (cart) => {
                  window.shopifyCart = cart.model;
                  const count = cart.model?.lineItems?.reduce((sum, item) => sum + (item.quantity || 1), 0) || 0;
                  const event = new CustomEvent('shopify-cart-update', {
                    detail: { count, checkoutUrl: cart.model?.webUrl }
                  });
                  window.dispatchEvent(event);
                },
                updateItemQuantity: (cart) => {
                  window.shopifyCart = cart.model;
                  const count = cart.model?.lineItems?.reduce((sum, item) => sum + (item.quantity || 1), 0) || 0;
                  const event = new CustomEvent('shopify-cart-update', {
                    detail: { count, checkoutUrl: cart.model?.webUrl }
                  });
                  window.dispatchEvent(event);
                }
              }
            }
          },
        });
      });
    };

    // Small delay to ensure DOM is ready
    const timer = setTimeout(loadShopifyBuyButton, 100);
    
    return () => clearTimeout(timer);
  }, [productId, productConfig]);

  if (!productConfig) return null;

  return (
    <div 
      id={productConfig.containerId} 
      data-testid={`shopify-buy-button-${productId}`}
      className="shopify-buy-button-container mt-6"
    />
  );
};

export default ShopifyBuyButton;
